export default __webpack_public_path__ + "static/media/IAE-Nice.5fd5c3b9.png";